import React from "react";

export const DashedLineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_30828_21593)">
      <path
        d="M15.3333 8.33325L0.666586 8.33325"
        stroke="#818181"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="4 4"
      />
    </g>
    <defs>
      <clipPath id="clip0_30828_21593">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
